export default __webpack_public_path__ + "static/media/noGuarantee.f139374b.svg";